import React from "react"
import { Fade } from "react-reveal"
import {
  Hero,
  HeroBoxVideo,
  HeroContent,
  HeroCta,
  HeroDescription,
  HeroOverlay,
  HeroTitle,
  HeroVideo,
} from "./hero.styles"
import { QUICKFIN_APP_URL } from "gatsby-env-variables"


export default function LandingHero() {
  let messages = [
    {
      title: `Tenha sempre <strong>dinheiro em caixa</strong>`,
      description: `<strong>Fornecedor</strong>, antecipe o dinheiro que você tem para
          receber em nossa plataforma, é rápido e fácil.`,
    },
    {
      title: `Tenha sempre <strong>dinheiro em caixa 2</strong>`,
      description: `<strong>Fornecedor</strong>, antecipe o dinheiro que você tem para
          receber em nossa plataforma, é rápido e fácil. 2`,
    },
  ]

  return (
    <Hero>
      <HeroContent>
        <Fade when={messages[0]}>
          <HeroTitle>
            <div dangerouslySetInnerHTML={{ __html: messages[0].title }} />
          </HeroTitle>
          <HeroDescription>
            <div
              dangerouslySetInnerHTML={{ __html: messages[0].description }}
            />
          </HeroDescription>
        </Fade>
        <HeroCta href={QUICKFIN_APP_URL + "/acesso/#/criar-conta"}>QUERO ME CADASTRAR</HeroCta>
      </HeroContent>
      <HeroBoxVideo>
        <HeroOverlay />
        <HeroVideo
          loop
          autoPlay
          playsInline
          muted
          className="canvas-video__Video-s76bwsi-1 gNNqcQ"
        >
          <source type="video/mp4" src="/v5.mp4" />
        </HeroVideo>
      </HeroBoxVideo>
    </Hero>
  )
}
